import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { api } from "../../api";

export function useListUsersInMyOrgs() {
  return useQuery({
    queryKey: ["user-admin", "users"],
    queryFn: () => api.listUsersInMyOrgs(),
    retry: (_, error) => {
      if (!(error instanceof AxiosError)) return true;
      // Don't retry on 403 or CORS-blocked network errors
      const status = error.response?.status;
      return status !== 401 && status !== 403 && error.code !== "ERR_NETWORK";
    },
  });
}
